import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
    padding: 12px 8px;
    background-color: ${(props) => props.theme.colors[props.color]};
    border-radius: 4px;
`;

const Highlighter = ({ children, color = 'surface-grey-050' }) => {
    return <Container color={color}>{children}</Container>;
};

Highlighter.propTypes = {
    children: PropTypes.node,
    color: PropTypes.string,
};

export default Highlighter;
